module.exports = __webpack_public_path__ + "static/img/zhnm.902c6e80.png";